<template>
  <div class="IberoForm">
    <div class="form-container">
      <div class="form-row">
        <div
          :id="'div_' + item.id"
          :class="[item.class]"
          class="nav"
          v-for="item of FieldsForm"
          :key="item.id"
          :v-if="item.hidden != true"
        >
          <div
            class="col-md-12"
            v-bind:class="[
              item.type === 'title' || item.type === 'summary'
                ? 'titleRefZone'
                : 'titleRef',
            ]"
          >
            {{ item.name }}
            <span
              v-if="item.tooltip"
              class="fa fa-commenting"
              :title="item.tooltip"
              :alt="item.tooltip"
            />
            <span class="summaryDat" v-if="item.type === 'summary'">{{
              ModelForm[item.model]
            }}</span>
          </div>
          <div
            class="inputRef col-md-12"
            v-if="item.type !== 'title' && item.type !== 'summary'"
          >
            <ValidationProvider
              :class="{ classes: true }"
              :name="item.name"
              :rules="item.validate"
              v-slot="{ classes, errors }"
            >
              <div v-if="item.type === 'password'">
                <input
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  type="password"
                  autocomplete="off"
                  maxlength="100"
                  :class="classes"
                />
              </div>
              <div v-else-if="item.type === 'input'">
                <input
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  :maxlength="item.validate.max"
                  @keyup="executeProcess"
                  @blur="executeProcess"
                />
              </div>
              <div v-else-if="item.type === 'autocomplete'">
                <vue-bootstrap-typeahead
                  :data="item.values"
                  :alt="item.id"
                  v-model="ModelForm[item.model]"
                  inputClass="form-control col-md-12"
                  :placeholder="item.placeholder"
                  :serializer="(item) => item.value"
                  @input="autocompleteNull"
                >
                </vue-bootstrap-typeahead>
              </div>
              <div v-else-if="item.type === 'inputAdd'">
                <input
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :idValidate="item.values"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  maxlength="100"
                  @blur="executeProcess"
                />
              </div>
              <div v-else-if="item.type === 'inputkey'">
                <input
                  autocomplete="off"
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  :maxlength="item.validate.max"
                  @click="executeProcess"
                  @keyup="executeProcess"
                />
              </div>
              <div v-else-if="item.type === 'file'" class="custom-file">
                <input
                  :id="item.id"
                  :placeholder="item.placeholder"
                  :idUbication="item.model"
                  class="custom-file-input col-md-12"
                  :class="classes"
                  type="file"
                  @change="executeProcess"
                />
                <label
                  class="custom-file-label"
                  data-browse="Archivo"
                  :for="item.id"
                  >Seleccionar archivos</label
                >
              </div>
              <div v-else-if="item.type === 'file_detail'">
                <div class="table-responsive-sm">
                  <table class="table">
                    <tbody>
                      <tr>
                        <th width="10%" scope="row">{{ item.idFile }}</th>
                        <td width="50%">{{ item.dataFile.Nam_File }}</td>
                        <td width="20%">{{ item.dataFile.Size }}</td>
                        <td width="20%" class="text-right">
                          <a :href="item.DetURI" target="_blank">
                            <img
                              width="20"
                              height="20"
                              src="@/assets/images/detail.png"
                              class="img-fluid"
                              title="Ver Documento"
                              alt="Ver Documento"
                            />
                          </a>
                          <img
                            v-if="item.delete"
                            width="20"
                            height="20"
                            src="@/assets/images/inactive.png"
                            class="img-fluid"
                            title="Eliminar Documento"
                            alt="Eliminar Documento"
                            @click="fileClosedFunction(item)"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else-if="item.type === 'Select'">
                <select
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  class="form-control col-md-12"
                  :disabled="item.disabled === true"
                  @change="executeProcess"
                  :class="classes"
                >
                  <option
                    value
                    selected="selected"
                    v-if="item.placeholder !== ''"
                  >
                    {{ item.placeholder }}
                  </option>
                  <option
                    v-for="itemList of item.values"
                    v-bind:value="itemList.id"
                    :key="itemList.id"
                  >
                    {{ itemList.value }}
                  </option>
                </select>
              </div>
              <div v-else-if="item.type === 'Select2'">
                <select
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  class="form-control col-md-12"
                  :disabled="item.disabled === true"
                  @change="executeProcess"
                  :class="classes"
                >
                  <option
                    value
                    selected="selected"
                    v-if="item.placeholder !== ''"
                  >
                    {{ item.placeholder }}
                  </option>
                  <option
                    v-for="itemList of item.values"
                    v-bind:value="itemList.nomenclature"
                    :key="itemList.nomenclature"
                    :code="itemList.codVal"
                  >
                    {{ itemList.value }}
                  </option>
                </select>
                <span class="form-control col-md-12">{{
                  ModelForm[item.model]
                }}</span>
              </div>

              <div v-else-if="item.type === 'datepicker'">
                <datepicker
                  v-model="ModelForm[item.model]"
                  :bootstrap-styling="true"
                  :monday-first="true"
                  :highlighted="item.dateTimePickerOptions.highlighted"
                  :disabled-dates="item.dateTimePickerOptions.disabledDates"
                  :format="item.dateTimePickerOptions.format"
                  :placeholder="item.placeholder"
                  :language="es"
                  :name="item.name"
                  :id="item.id"
                  :input-class="classes"
                  @closed="datepickerClosedFunction(item)"
                ></datepicker>
              </div>
              <div
                v-else-if="item.type === 'accepted'"
                class="custom-control custom-checkbox"
              >
                <input
                  v-model="ModelForm[item.model]"
                  type="checkbox"
                  :id="'cbox_' + item.id"
                  @change="executeProcess"
                  :class="classes"
                  :disabled="item.disabled"
                  class="custom-control-input"
                />&nbsp;
                <label
                  class="custom-control-label"
                  :for="'cbox_' + item.id"
                  v-html="item.placeholder"
                  @click="executeProcess"
                ></label>
              </div>
              <div v-else-if="item.type === 'ClearZone'"></div>
              <div v-else-if="item.type === 'informative'">
                <strong>{{ ModelForm[item.model] }}</strong>
              </div>
              <div v-else-if="item.type === 'textarea'">
                <textarea
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  :maxlength="item.validate.max"
                  @keyup="executeProcess"
                  @blur="executeProcess"
                >
                </textarea>
                <div v-if="item.values">
                  <div v-html="item.values" class="notaResumen" />
                </div>
              </div>
              <div v-else-if="item.type === 'html'">
                <div v-html="item.values"></div>
              </div>
              <div v-else-if="item.type === 'radio'">
                <div class="radioClass row">
                  <div
                    v-for="(itemList, ref) of item.values"
                    class="custom-control custom-radio col-md-2"
                    :key="itemList.id"
                  >
                    <input
                      @change="executeProcess"
                      v-model="ModelForm[item.model]"
                      class="custom-control-input"
                      type="radio"
                      :id="item.id + '_' + itemList.id"
                      :name="item.id"
                      :value="itemList.value"
                      v-bind:checked="[ref === 1 ? 'checked' : '']"
                    />
                    <label
                      class="custom-control-label"
                      :for="item.id + '_' + itemList.id"
                      >{{ itemList.value }}</label
                    >
                  </div>
                </div>
              </div>
              <div v-else-if="item.type === 'check'">
                <div class="radiocheck row">
                  <div
                    v-for="itemList of item.values"
                    class="custom-control custom-checkbox col-md-6"
                    :key="itemList.id"
                  >
                    <input
                      @change="executeProcess"
                      v-model="ModelForm[item.model]"
                      class="custom-control-input"
                      type="checkbox"
                      :id="item.id + '_' + itemList.id"
                      :name="item.id"
                      :value="itemList.value"
                    />
                    <label
                      class="custom-control-label"
                      :for="item.id + '_' + itemList.id"
                      >{{ itemList.value }}</label
                    >
                  </div>
                </div>
              </div>
              <div v-else-if="item.type === 'button'">
                <button
                  :id="'btn_' + item.id"
                  :disabled="item.disabled"
                  type="submit"
                  v-on:click="executeProcess"
                  class="btn btn-primary btn-lg btn-block botonRef"
                >
                  {{ item.placeholder }}
                </button>
              </div>
              <div v-else-if="item.type === 'stars'">
                <p class="clasificacion">
                  <input
                    id="radio1"
                    type="radio"
                    name="estrellas"
                    value="5"
                  /><!--
    --><label for="radio1">★</label
                  ><!--
    --><input id="radio2" type="radio" name="estrellas" value="4" /><!--
    --><label for="radio2">★</label
                  ><!--
    --><input id="radio3" type="radio" name="estrellas" value="3" /><!--
    --><label for="radio3">★</label
                  ><!--
    --><input id="radio4" type="radio" name="estrellas" value="2" /><!--
    --><label for="radio4">★</label
                  ><!--
    --><input id="radio5" type="radio" name="estrellas" value="1" /><!--
    --><label for="radio5">★</label>
                </p>
              </div>
              <div v-else-if="item.type === 'radiostar'">
                <div class="radioClass row">
                  <div
                    v-for="(itemList, ref) of item.values"
                    class="custom-control custom-radio col-md-2"
                    :key="itemList.id"
                  >
                    <input
                      @change="executeProcess"
                      v-model="ModelForm[item.model]"
                      class="custom-control-input clasificacion"
                      type="radio"
                      :id="item.id + '_' + itemList.id"
                      :name="item.id"
                      :value="itemList.value"
                      v-bind:checked="[ref === 1 ? 'checked' : '']"
                    />
                    <label
                      class="custom-control-label label1"
                      :for="item.id + '_' + itemList.id"
                      >★{{ itemList.value }}</label
                    >
                  </div>
                </div>
              </div>
              <div v-else>
                Requiere un formato correcto para el campo del formulario
              </div>
              <div class="is-invalid-form">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

export default {
  name: 'IberoForm',
  methods: {
    executeProcess (event) {
      this.method(event)
    },
    datepickerClosedFunction (dataref) {
      var event = {}
      var target = {}
      target.id = dataref.id
      // target.value = dataref.values             //////////
      target.value = this.ModelForm[dataref.model]
      event.target = target
      this.method(event)
    },
    autocompleteSelect (dataref) {
      var events = {}
      var target = {}
      target.id = dataref.id
      target.value = this.ModelForm[dataref.model]
      target.event = dataref
      events.target = target
      this.method(events)
    },
    autocompleteNull (dataref) {
      if (dataref === '') {
        var events = {}
        var target = {}
        target.id = event.path[6].id
        target.value = dataref
        target.event = event
        events.target = target
        this.method(events)
      }
    },
    fileClosedFunction (dataref) {
      this.method(dataref)
    },
  },
  data () {
    return {
      es: es,
      autocompleteInput: null,
    }
  },
  components: {
    Datepicker,
    VueBootstrapTypeahead,
  },
  props: {
    method: Function,
    ModelForm: Object,
    FieldsForm: Array,
  },
}
</script>

<style>
.botonRef {
  color: #222 !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
}

.btn-primary:hover {
  color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-weight: bold;
}

.titleRef {
  font-weight: bold;
  padding-bottom: 0px;
  margin-top: 30px;
}

.titleRefZone {
  color: #d0ab4b;
  font-weight: bold;
  font-size: 16px;
  border-style: solid;
  border-bottom-width: 1px;
  padding-top: 10px;
  margin-top: 10px;
}

.fa-commenting {
  color: #222 !important;
  cursor: pointer;
  padding-left: 10px;
}

.datepicker {
  padding-bottom: 30px;
}

.is-invalid-form {
  color: red;
  height: 10px;
  font-size: 12px;
}

.form-control {
  margin-top: 10px !important;
  margin-bottom: 0px !important;
}

.table {
  width: 100%;
}
.img-fluid {
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
}

.radioClass {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.radiocheck {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.noShow {
  display: none;
}

.linkTerm {
  cursor: pointer;
}

.notaResumen {
  color: #000000 !important;
  font-style: italic;
  font-size: 10px;
  font-weight: bold;
}

.summaryDat {
  float: right;
}

#wrapper {
  padding-top: 50px;
  width: 400px;
  margin: 0 auto 0 auto;
}
.label1 {
  font-size: 20px;
  color: grey;
}

.clasificacion {
  direction: rtl;
  unicode-bidi: bidi-override;
}

label1:hover,
label1:hover ~ label {
  color: orange;
}

input[type="radio"]:checked ~ label {
  color: orange;
}
</style>
